// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__0NvU6","pagination":"pagination_pagination__djZ22","button":"pagination_button__i9hkS","buttongroup":"pagination_buttongroup__QDehL"};